import axios from 'axios';
import Swal from 'sweetalert2';


const CloseActiveMission = (p_relevant_url,p_mission_id,p_mission_type) =>{ 
    
    if(!p_mission_id || !p_mission_type || !p_relevant_url)  return;
    
    //  asking before releasing the cart + reservation ;  
    Swal.fire({
        title: `<html><p style='font-size:20px'> Are You Sure ?</p></html>`,
        text:'If you continue mission will close.',
        icon: 'warning',
        showDenyButton: true,
        confirmButtonText: 'Yes',
        position:'center',
        confirmButtonColor:'#00A7EE',
        denyButtonText: 'No',
        // disable backdrop animation
        showClass: { 
        popup: '',                
          },
        hideClass:{
            popup:''
        },
        customClass: {
            container: 'my-swal'
        }
    })
        .then((result) => {
                if (!result.isConfirmed) return; // user cancelled
                                axios.post(p_relevant_url + '/admin/closeActiveMission', {mission_id:p_mission_id,mission_type:p_mission_type})
                                    .then(res => {
                                        console.log('closeActiveMission response', res.data);
                                        // Success modal styled exactly like the warning (reuse same classes & structure)
                                        Swal.fire({
                                            title: `<html><p style='font-size:20px'> Mission Closed </p></html>`,
                                            text: 'The mission has been closed successfully.',
                                            icon: 'success',
                                            position: 'center',
                                            confirmButtonText: 'OK',
                                            confirmButtonColor: '#00A7EE',
                                            showClass: { popup: '' },
                                            hideClass: { popup: '' },
                                            customClass: { container: 'my-swal' }
                                        });
                    })
                    .catch(err => {
                        console.error('closeActiveMission error', err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Failed to close mission',
                            text: (err?.response?.data && typeof err.response.data === 'string') ? err.response.data : 'Please try again.'
                        });
                    });
        })
   
    return;
}

export default CloseActiveMission;